import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Index from "@/pages/Index";
import "./App.css";
import { Toaster } from "@/components/ui/toaster";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import PlayerCard from "@/pages/PlayerCard";
import { DevButton } from "@/components/dev/DevButton";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const [isProcessingAuth, setIsProcessingAuth] = useState(false);
  
  // Handle magic link authentication
  useEffect(() => {
    // Check if we're at the auth callback hash route
    if (location.hash === '#auth-callback' && !isProcessingAuth) {
      console.log('Auth callback detected, processing session...');
      setIsProcessingAuth(true);
      
      // Check if we have a session
      const checkSession = async () => {
        try {
          const { data, error } = await supabase.auth.getSession();
          
          if (error) {
            console.error("Session error:", error);
            return;
          }
          
          if (data.session) {
            console.log('Valid session detected after auth callback');
            
            // Store the email in localStorage
            if (data.session.user?.email) {
              localStorage.setItem("user_email", data.session.user.email);
            }
            
            // Reset the URL by removing the hash
            window.history.replaceState(null, '', '/');
            
            // Prevent any new auth callback processing while refreshing
            const reloadTimeout = setTimeout(() => {
              window.location.reload();
            }, 500);
            
            return () => clearTimeout(reloadTimeout);
          } else {
            console.log('No valid session found after auth callback');
          }
        } catch (err) {
          console.error("Error handling auth callback:", err);
        } finally {
          setIsProcessingAuth(false);
        }
      };
      
      checkSession();
    }
  }, [location, navigate, toast, isProcessingAuth]);
  
  // Check for existing session on app load
  useEffect(() => {
    const checkExistingSession = async () => {
      try {
        const { data } = await supabase.auth.getSession();
        if (data.session?.user?.email) {
          localStorage.setItem("user_email", data.session.user.email);
        }
      } catch (error) {
        console.error("Error checking session:", error);
      }
    };
    
    checkExistingSession();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/player-card/:attemptId" element={<PlayerCard />} />
      </Routes>
      <Toaster />
      
      {/* Always show the dev button */}
      <DevButton />
    </>
  );
}

export default App;
